import { render, staticRenderFns } from "./ConsultaCartera.vue?vue&type=template&id=1dbcc840&"
import script from "./ConsultaCartera.vue?vue&type=script&lang=js&"
export * from "./ConsultaCartera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports